<template>
  <div>
    <el-form label-width="120px" :model="editForm" :rules="rules" ref="editForm" size="small" :disabled="onlyView">
      <el-row :gutter="50">
        <el-col :span="12">
          <el-form-item label="发票抬头" prop="title">
            <el-input v-model="editForm.title" auto-complete="off" placeholder="请输入发票抬头"
                      maxlength="50"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="纳税人识别号" prop="taxNumber">
            <el-input v-model="editForm.taxNumber" auto-complete="off" placeholder="请输入纳税人识别号"
                      maxlength="50"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="开户银行" prop="bank">
            <el-input v-model="editForm.bank" auto-complete="off" placeholder="请输入开户银行"
                      maxlength="50"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="银行账号" prop="bankAccount">
            <el-input v-model="editForm.bankAccount" auto-complete="off" placeholder="请输入银行账号"
                      maxlength="50"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="联系人" prop="contact">
            <el-input v-model="editForm.contact" auto-complete="off" placeholder="请输入联系人"
                      maxlength="50"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="联系电话" prop="mobile">
            <el-input v-model="editForm.mobile" auto-complete="off" placeholder="请输入联系电话"
                      maxlength="20"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="是否默认" prop="isDefault">
            <el-radio-group v-model="editForm.isDefault">
              <el-radio :label="0">是</el-radio>
              <el-radio :label="1">否</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="单位地址" prop="address">
            <el-input type="textarea" v-model="editForm.address" auto-complete="off" placeholder="请输入单位地址" rows="4"
                      maxlength="400"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
import _ from 'lodash'
import { getInfo } from '@/api/user/userInvoice'
export default {
  data () {
    return {
      // rules表单验证
      rules: {
        title: [{ required: true, message: '请输入发票抬头', trigger: 'blur' }],
        taxNumber: [{ required: true, message: '请选择类别', trigger: 'blur' }],
        mobile: [{ required: true, message: '请输入联系电话', trigger: 'blur' }]
      },
      editForm: {
      },
      inputVisible: false,
      inputValue: '',
      onlyView: false,
      type: ''
    }
  },
  props: ['edit'],
  mounted () {
    this.editForm = _.cloneDeep(this.edit)
    this.type = this.editForm.pageType
    // if (this.editForm.pageType === 'edit' || this.editForm.pageType === 'view') {
    //   this.getDetail()
    // }
    if (this.editForm.pageType === 'view') {
      this.onlyView = true
    }
  },
  methods: {
    getDetail () {
      getInfo(this.editForm).then(res => {
        var result = res.data
        if (result.rtnCode !== '0') {
          this.$message({
            type: 'info',
            message: result.msg
          })
        } else {
          this.editForm = result.bizData
          this.editForm.pageType = this.type
        }
      }).catch(ex => {
        this.loading = false
        this.$message.error('获取详情失败，请稍后再试！')
      })
    }
  }
}
</script>
